module.exports = __webpack_public_path__ + "static/machine_learning_LS@2x-e0125efd06df3e3774251f0e391df680.png";